export { Heading } from "native-base";
